import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import BookingManagement from 'tenants/sealink/booking_management';

reactOnCms.register({
  ManageBooking: BookingManagement,
});
